module.exports = __webpack_public_path__ + "img/CR.aaf65b48.svg";